<div class="flex min-h-screen bg-gray-50 dark:bg-black">
    <!-- Sidebar: desktop -->
    <div
        class="sticky top-0 left-0 z-50 hidden h-screen w-64 shrink-0 flex-col overflow-y-auto border-r border-gray-100 bg-white shadow-md md:flex dark:border-gray-800 dark:bg-black/40">
        <app-sidebar-admin></app-sidebar-admin>
    </div>

    <!-- Sidebar drawer: mobile (same pattern as layout-default) -->
    <div
        class="fixed inset-0 z-50 backdrop-blur-[1.5px] transition-opacity duration-400 md:hidden"
        [style.background-color]="
            isMobileSidebarOpen() ? 'rgba(0, 0, 0, 0.3)' : 'transparent'
        "
        [style.pointer-events]="isMobileSidebarOpen() ? 'auto' : 'none'"
        [style.opacity]="isMobileSidebarOpen() ? '1' : '0'"
        (click)="closeMobileSidebar()">
        <div
            class="absolute top-0 left-0 h-full w-64 transform bg-white shadow-lg transition-transform duration-400 ease-in-out dark:bg-black/90"
            [class.-translate-x-full]="!isMobileSidebarOpen()"
            [class.translate-x-0]="isMobileSidebarOpen()">
            <app-sidebar-admin
                (navigated)="closeMobileSidebar()"></app-sidebar-admin>
        </div>
    </div>

    <section class="min-w-0 flex-1 overflow-x-hidden">
        <app-header-admin
            class="sticky top-0 z-40 block"
            (sidebarToggle)="toggleMobileSidebar()"></app-header-admin>

        <main class="p-4">
            <ng-content></ng-content>
        </main>
    </section>
</div>
